import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-leave-management-solution',
  imports: [RouterModule, FeatureHero],
  templateUrl: './leave-management-solution.html',
  styleUrl: './leave-management-solution.scss',
})
export class LeaveManagementSolution {

}
